import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "message"]

  connect() {
    this.verified = true
    this.onCallback = () => this.setVerified(true)
    this.onProblem = () => this.setVerified(false)

    window.addEventListener("mtg:turnstile-callback", this.onCallback)
    window.addEventListener("mtg:turnstile-expired", this.onProblem)
    window.addEventListener("mtg:turnstile-error", this.onProblem)

    window.mtgTurnstileCallback = () => window.dispatchEvent(new CustomEvent("mtg:turnstile-callback"))
    window.mtgTurnstileExpired = () => window.dispatchEvent(new CustomEvent("mtg:turnstile-expired"))
    window.mtgTurnstileError = () => window.dispatchEvent(new CustomEvent("mtg:turnstile-error"))
  }

  disconnect() {
    window.removeEventListener("mtg:turnstile-callback", this.onCallback)
    window.removeEventListener("mtg:turnstile-expired", this.onProblem)
    window.removeEventListener("mtg:turnstile-error", this.onProblem)
  }

  setVerified(verified) {
    this.verified = verified
    this.element.dataset.turnstileVerified = String(verified)
    this.submitTargets.forEach((submit) => {
      submit.disabled = !verified || ["pending", "failed"].includes(this.element.dataset.trayImport)
    })

    if (this.hasMessageTarget) {
      this.messageTarget.classList.toggle("d-none", verified)
    }
  }
}
